import {AxiosError} from 'axios';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import postExtendAdvertisement from './postExtendAdvertisement';
import postExtendRequirement from './postExtendRequirement';

interface IExtendPayload {
  advertisement_id: string;
  type: 'requirement' | 'advertisement';
}

const usePostExtend = (handleAfterSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: ({advertisement_id, type}: IExtendPayload) => {
      return type === 'advertisement'
        ? postExtendAdvertisement(advertisement_id)
        : postExtendRequirement(advertisement_id);
    },
    onSuccess: data => {
      handleAfterSuccess && handleAfterSuccess();
      queryClient.invalidateQueries(['get-my-store-ads']);
      queryClient.invalidateQueries(['advertisement-detail']);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostExtend;
